module.exports = __webpack_public_path__ + "static/profile-4f79efb2c680172377a94a5ca9b923d5.png";